<!--
  详情页 - 红冲合同 - 作废发票
  props:
    id: 详情id
  emit:
    openDetail: 打开详情页
 -->

<template>
  <div class="v-tabs notes-list">
    <div class="head">
      <div class="total">
        关联作废发票：{{listData.length}} 张
        <span v-if="totalAmount"> 开票总额：{{totalAmount}}元</span>
      </div>
    </div>
    <div class="content" ref="content">
      <ul class="item-list">
        <li class="item center" v-if="!listData.length">暂无数据</li>
        <li class="item hc-red" v-for="item in listData">
          <span class="date">{{item.invoiceDate}}</span>
          <div class="order">
            <div class="id">
              <i class="ico orange">￥</i>
              <a @click="openDetail(item.id)">{{item.sheetNo}}</a>
            </div>
            <div class="good">
              <span class="thumb">
                <i class="web-icon-dollar-circle"></i>
              </span>
              <span class="title">￥{{item.totalMoney}}</span>
            </div>
            <div class="response">申请人：{{item.userName}}</div>
            <span class="status">已作废</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    },
    moduleName: String,
    approvalId: Number
  },
  data () {
    return {
      listData: [],
      totalAmount: 0
    }
  },
  methods: {
    openDetail (id) {
      this.$emit('openDetail', 'invoice', id)
    },
    getList () {
      let url
      let params
      if (this.approvalId) {
        url = '/refund/getRefundInvoices.html'
        params = {
          id: this.id
        }
      } else {
        url = '/refund/getCancelInvoice.html'
        params = {
          refId: this.id,
          refType: this.moduleName
        }
      }
      api.post(url, params, (data) => {
        this.listData = data.result
        this.totalAmount = data.totalAmount
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// canceled-invoice.vue?f63c7ab0